import { render, staticRenderFns } from "./payment-initiated.vue?vue&type=template&id=3892e926&scoped=true&"
import script from "./payment-initiated.vue?vue&type=script&lang=js&"
export * from "./payment-initiated.vue?vue&type=script&lang=js&"
import style0 from "./payment-initiated.vue?vue&type=style&index=0&id=3892e926&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3892e926",
  null
  
)

export default component.exports